import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";
import { StatusReservaEnum } from "core/features/reservas/typings";

const SelectableTag = ({
  value,
  tipo,
  text,
  onChange,
  onUnselect,
}: {
  value?: StatusReservaEnum;
  tipo: StatusReservaEnum;
  text: string;
  onChange: (v: StatusReservaEnum | null) => void;
  onUnselect: () => any;
}) => (
  <SelectableButton
    selected={value === tipo}
    onClick={() => {
      onChange(tipo);
    }}
    onUnselect={onUnselect}
    rounded="full"
    selectedColor={getColor(tipo)}
    fontSize="14px"
  >
    {text}
  </SelectableButton>
);

function FiltroTags({
  value,
  onChange,
}: {
  value?: StatusReservaEnum;
  onChange: (v?: StatusReservaEnum | null) => void;
}) {
  const onUnselect = () => onChange(null);

  return (
    <Flex flex={1} gridGap="12px" flexWrap="wrap">
      <SelectableTag
        tipo={StatusReservaEnum.Confirmada}
        text="Confirmada"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={StatusReservaEnum.Pendente}
        text="Pendente"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={StatusReservaEnum.AguardandoPagamento}
        text="Aguardando Pagamento"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />
      <SelectableTag
        tipo={StatusReservaEnum.Cancelada}
        text="Cancelada"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />
    </Flex>
  );
}

export function getColor(tipo: StatusReservaEnum) {
  if (tipo === StatusReservaEnum.Confirmada) {
    return "#4EC98A";
  }

  if (tipo === StatusReservaEnum.Cancelada) {
    return colors.red;
  }

  if (tipo === StatusReservaEnum.AguardandoPagamento) {
    return colors.yellow;
  }

  if (tipo === StatusReservaEnum.Pendente) {
    return "orange";
  }
}

export default FiltroTags;
